import { useState } from "react";
import styles from "./input.module.css";

import Label from "../Label";
import ErrorLabel from "../Label/errorLabel";
import Visibility from "../../images/visibilitiy";
import VisibilityOff from "../../images/visibilityOff";

const Input = ({
  isTextArea,
  label,
  name,
  value,
  type = "text",
  placeholder = "",
  error,
  helperText,
  required = false,
  rows = 5,
  className,
  inputClassName = "",
  disabled,
  endAdorment,
  onBlur,
  onChange,
  autoComplete,
}) => {
  const El = isTextArea ? "textarea" : "input";
  const extraProps = isTextArea
    ? { rows }
    : { autoComplete: autoComplete ?? "on" };

  const [showPassword, setShowPassword] = useState(false);
  const isPasswordInput = type === "password";

  const Icon = showPassword ? Visibility : VisibilityOff;

  return (
    <div className={className}>
      <Label label={label} name={name} required={required} />
      <div className={styles.inputWrapper}>
        <El
          type={isPasswordInput && showPassword ? "text" : type}
          id={name}
          name={name}
          value={value ?? ""}
          className={`${styles.input} ${
            error ? styles.inputError : styles.inputBase
          } ${inputClassName}`}
          placeholder={placeholder}
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
          onWheel={(e) => {  if (type === "number") {
              e.preventDefault();
              e.stopPropagation();
              e.target.blur();
            }
          }}
          {...extraProps}
        />
        {isPasswordInput && (
          <Icon
            className={styles.icon}
            onClick={() => setShowPassword((p) => !p)}
          />
        )}
        {endAdorment && <div className={styles.endAdorment}>{endAdorment}</div>}
      </div>
      {error && <ErrorLabel>{helperText}</ErrorLabel>}
    </div>
  );
};

export default Input;
